import { render, staticRenderFns } from "./PaymentInvoice.vue?vue&type=template&id=56219042&scoped=true"
var script = {}
import style0 from "./PaymentInvoice.vue?vue&type=style&index=0&id=56219042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56219042",
  null
  
)

export default component.exports